import type React from 'react';
import type { FC } from 'react';

import PrimaryButton from '@crehana/ui/dist/Buttons/PrimaryButton';
import { clsx } from 'clsx';

import type { DialogActionsProps } from './types';

const DialogActions: FC<React.PropsWithChildren<DialogActionsProps>> = ({
  isDark = false,
  ButtonProps,
}) => (
  <div
    className={clsx(
      'flex items-center justify-between min-h-72 px-36',
      isDark ? 'bg-base-main-dark-mode' : 'bg-gray-lighter',
    )}
  >
    <div className="text-center font-caption text-base-lighter">
      * Todos los campos son obligatorios
    </div>
    <PrimaryButton
      type="submit"
      size="s"
      label="Guardar"
      className="mb-8"
      darkMode={isDark}
      {...ButtonProps}
    />
  </div>
);

export default DialogActions;
